import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text';
import {EvenOddListItemContentFactoryProps} from '../../../../../shared/components/evenOddList';
import {maskPrivateData} from '../../../../../shared/pipes/maskPrivateData';
import {PhoneChangeField} from '../../../common/phoneChangeField';
import {EmailChangeField} from '../../../common/emailChangeField';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {themeSelector} from '../../../../../redux/selectors/runtime/theme';
import {VisImpFontSize} from '../../../../../shared/models/visuallyImpairedSettings';
import {useConfirmEmail} from '../../../../../shared/hooks/useConfirmEmail';

export interface ProfileUserContactsRoute {
  params: {
    op: string;
    code: string;
  };
}

export const ProfileUserContacts: React.FC<{route: ProfileUserContactsRoute}> = ({
  route: {params: {op = '', code = ''} = {}},
}) => {
  const themeSettings = useSelector(themeSelector());
  const isEmailConfirmationNeeded = React.useMemo(() => !!(op === 'changeEmail' && code), [op, code]);
  const [isLoading, setIsLoading] = React.useState(isEmailConfirmationNeeded);

  useConfirmEmail(isEmailConfirmationNeeded, code, setIsLoading);

  const styles = useStyles(({theme}) => {
    return {
      prop: {
        ...theme.fonts.body,
        textAlign: 'right',
        maxWidth: `${themeSettings?.fontSize === VisImpFontSize.Large ? 50 : 60}%`,
        color: theme.color.textColor,
        opacity: 1,
      },
      label: {
        ...theme.fonts.bodySmallLight,
        color: theme.color.labelText,
        maxWidth: `${themeSettings?.fontSize === VisImpFontSize.Large ? 52 : 38}%`,
      },
      text: {
        color: theme.color.textColor,
      },
    };
  });

  const profile = useSelector(holderProfileSelector());
  if (!profile) return null;

  const addresses = [
    {
      value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
        <>
          <Text style={styles.label}>Регистрации</Text>
          <Text style={[styles.prop, styles.text]}>
            {isMasked ? maskPrivateData(profile?.passport?.addressReg?.slice(0, 10)) : profile?.passport?.addressReg}
          </Text>
        </>
      ),
    },
    {
      value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
        <>
          <Text style={styles.label}>Проживания</Text>
          <Text style={[styles.prop, styles.text]}>
            {isMasked ? maskPrivateData(profile.address?.slice(0, 10)) : profile.address}
          </Text>
        </>
      ),
    },
  ];

  const phone = [
    {
      value: <PhoneChangeField isMasked onDisableMasking={() => undefined} />,
    },
  ];

  const email = [
    {
      value: <EmailChangeField isMasked onDisableMasking={() => undefined} />,
    },
  ];

  return (
    <LoadableContent loading={isLoading}>
      <View addresses={addresses} phone={phone} email={email} profile={profile} />
    </LoadableContent>
  );
};
